// extracted by mini-css-extract-plugin
module.exports = {"quote_img":"Review_quote_img__WqSbE","info":"Review_info___oxGc","btn_hover":"Review_btn_hover__QXZ0Q","color":"Review_color__g68Rg"};